import { Picker, DatePicker, Switch, Radio } from 'antd-mobile';

import { appMethod as app } from '@utils/app';
import util from '@utils/util'; 
import { getCurrentPageQueryParams, convertLineStyleData, convertHtmlTag, convertTagStyle } from '@utils/tools';
import OfficialPage from '../OfficialPage';

import './PreviewOrderDetail.less';

// 可兑换券底部弹窗
let ExchangeCouponUseDialogTmpl = (options) => {
  const { data, self } = options;
  const {
    dialogHidden,
    selectModelInfo,
    goodsInfo,
    model,
    modelIndex,
    index,
    name
  } = data;

  return <React.Fragment>
    <div
      className="page-dialog-wrap page-addshoppingcart-dialog tostorePay-coupon-wrap"
      hidden={dialogHidden}
    >
      <div className="page-bottom-dialog" style={convertLineStyleData('padding-bottom: 65px;')}>
        <div className="page-bottom-content">
          <div
            className="pay-close-dialog page-dialog-close"
            onClick={self.exchangeCouponHideDialog}
          >
            ×
              </div>
          <div className="dialog-block-item">
            <div className="thumb">
              <div className="thumb-wrap">
                <img
                  className="pay-goods-cover"
                  src={selectModelInfo.imgurl || goodsInfo.cover}
                />
              </div>
            </div>
            <div className="pay-goods-baseinfo">
              <div
                className="pay-goods-title ellipsis"
                style={convertLineStyleData('text-align: left;')}
              >
                <span>{goodsInfo.title}</span>
                <span className="gift-text">赠品</span>
              </div>
              {selectModelInfo.models_text && (
                <div className="pay-checked-text clearfix">
                  {'已选：' + selectModelInfo.models_text}
                </div>
              )}
            </div>
          </div>
          <div
            className="dialog-block-item"
            hidden={!(goodsInfo.model_items && goodsInfo.model_items.length)}
          >
            <div className="pay-goods-models">
              {goodsInfo.model && goodsInfo.model.map((model, modelIndex) => {
                return (
                  <div key={modelIndex}>
                    <span style={convertLineStyleData('vertical-align:top;float: left;margin-top: 5px;width:120rpx;display:inline-block;text-align:right;font-size:24rpx;')}>
                      {model.name + '：'}
                    </span>
                    <label
                      className="pills-list"
                      style={convertLineStyleData('text-align:center;max-width:528rpx;')}
                    >
                      {model.subModelName.map((name, index) => {
                        return (
                          <label
                            key={index}
                            data-model-index={modelIndex}
                            data-submodel-index={index}
                            className={
                              'subModel ' +
                              (selectModelInfo.models[modelIndex] ==
                                model.subModelId[index]
                                ? 'select'
                                : '')
                            }
                            data-submodel-id={model.subModelId[index]}
                            onClick={self.exchangeCouponSelectSubModel}
                          >
                            {name}
                          </label>
                        )
                      })}
                    </label>
                  </div>
                )
              })}
            </div>
          </div>
          <div
            className="toStore-bottom-nav"
            style={convertLineStyleData('background-color:#3f3f3f;')}
          >
            <div className="bottom-nav-detail"></div>
            <div
              className="bottom-nav-ready"
              onClick={self.exchangeCouponConfirmGoods}
            >
              选好了
                </div>
          </div>
        </div>
      </div>
    </div>
  </React.Fragment>
}

export default class PreviewOrderDetail extends OfficialPage {
  state = {
    goodsList: [],
    wayOfDine: 1, // 1: 点餐, 2: 预约
    discountDialogHidden: true,
    discountList: [],
    selectDiscountInfo: '',
    selectDiscountIndex: -1,
    discount_cut_price: '',
    appointmentTime: '',
    phone: '',
    orderRemark: '',
    optionalTimeStart: '',
    optionalTimeEnd: '',
    location_data_arr: '',
    locationNum: '',
    locationId: 0,
    changeValue: 0,
    selectLocationId: '',
    locationTitle: '',
    isUrlLocationId: '',
    balance: '',
    useBalance: true,
    deduction: '',
    exchangeCouponData: {
      dialogHidden: true,
      goodsInfo: {},
      selectModelInfo: {},
      hasSelectGoods: false,
      voucher_coupon_goods_info: {}
    },
    leagueBenefitList: [], // 联盟优惠列表
    selectedLeagueBenefitInfo: '', // 选中的联盟优惠
    selectedLeagueBenefitIndex: -1, // // 联盟优惠下标
    leagueBenefitPrice: '' // 联盟优惠优惠价格
  }
  changeNumTimeout = []
  franchiseeId = ''
  cartIdArr = []
  cartGoodsIdArr = []
  cart_data_arr = []
  cart_id_arr = []
  isPaysuccessFlag = false
  isFranchisee = false

  constructor(props) {
    super(props);
    document.title = '确认支付';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.franchiseeId = options.franchisee || ''
    let isFranchisee = options.isFranchisee ? true : false
    if (!this.isFranchisee) {
      let {
        goodsStoreConfig,
        hasFranchiseeList,
        hasFranchiseeChain
      } = app.globalData
      if (
        goodsStoreConfig['cart_config'] &&
        goodsStoreConfig['cart_config'].is_merge_shoppingcart == 1
      ) {
        // 是否开启合并购物车
        if (hasFranchiseeList || hasFranchiseeChain) {
          isFranchisee = true
        }
      }
    }
    this.isFranchisee = isFranchisee
    this.cart_id_arr = options.cart_arr
      ? decodeURIComponent(options.cart_arr).split(',')
      : []
    this.dataInitial()
    if (app.globalData.urlLocationId) {
      this.setData({
        isUrlLocationId: app.globalData.urlLocationId,
        locationId: app.globalData.urlLocationId,
        changeValue: 2
      })
      this.getDataId()
    }
  }

  dataInitial = () => {
    this.getCartList()
    this.location()
    this.GetTostoreWaitingRule()
  }
  getCartList = () => {
    var that = this,
      franchiseeId = this.franchiseeId
    app.sendRequest({
      url: '/index.php?r=AppShop/cartList',
      data: {
        page: 1,
        page_size: 100,
        sub_shop_app_id: franchiseeId,
        parent_shop_app_id: franchiseeId ? app.globalData.appId : ''
      },
      success: function (res) {
        var shoppingCartdata = [],
          tostoreData = []
        if (that.cart_id_arr.length) {
          for (var i = 0; i <= res.data.length - 1; i++) {
            if (that.cart_id_arr.indexOf(res.data[i].id) >= 0) {
              shoppingCartdata.push(res.data[i])
            }
          }
        } else {
          shoppingCartdata = res.data
        }
        for (var i = 0; i < shoppingCartdata.length; i++) {
          if (shoppingCartdata[i].goods_type == 3) {
            tostoreData.push(shoppingCartdata[i])
          }
        }
        for (var i = 0; i <= tostoreData.length - 1; i++) {
          var goods = tostoreData[i],
            modelArr = goods.model_value
          goods.model_value_str =
            modelArr && modelArr.join ? '(' + modelArr.join('|') + ')' : ''
          that.cart_data_arr.push({
            cart_id: goods.id,
            goods_id: goods.goods_id,
            model_id: goods.model_id,
            num: goods.num
          })
          that.cartIdArr.push(goods.id)
          that.cartGoodsIdArr.push(goods.goods_id)
        }
        that.setData({
          goodsList: tostoreData,
          phone: app.getUserInfo().phone
        })
        that.getCalculationPrice()
        that.getOptionalTime()
      }
    })
  }
  getCalculationPrice = changeBenefit => {
    var that = this,
      franchiseeId = this.franchiseeId,
      selectDiscountInfo = this.data.selectDiscountInfo,
      selectedLeagueBenefitInfo = this.data.selectedLeagueBenefitInfo,
      // 联盟优惠
      selectDiscountIndex = '',
      selectedLeagueBenefitIndex = ''
    if (changeBenefit == 'changeGoodNum') {
      selectDiscountInfo = ''
    }
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/calculationPrice',
      method: 'post',
      data: {
        sub_shop_app_id:
          franchiseeId || (this.isFranchisee ? app.getAppId() : ''),
        cart_id_arr: that.cartIdArr,
        is_self_delivery: 1,
        is_balance: this.data.useBalance ? 1 : 0,
        selected_benefit: selectDiscountInfo,
        voucher_coupon_goods_info: this.data.exchangeCouponData
          .voucher_coupon_goods_info,
        superimposed: this.isFranchisee ? 1 : 0,
        extra_selected_benefit: selectedLeagueBenefitInfo
      },
      success: function (res) {
        var discounts = res.data.can_use_benefit.data
        let newData = {}
        if (discounts && discounts.length) {
          discounts.unshift({
            title: '不使用优惠',
            name: '无',
            no_use_benefit: 1
          })
        }
        selectDiscountInfo = res.data.selected_benefit_info
        if (selectDiscountInfo && selectDiscountInfo.discount_type) {
          for (var i = 0; i <= discounts.length - 1; i++) {
            if (
              selectDiscountInfo.discount_type === discounts[i].discount_type
            ) {
              if (selectDiscountInfo.discount_type === 'coupon') {
                if (selectDiscountInfo.coupon_id === discounts[i].coupon_id) {
                  selectDiscountIndex = i
                  break
                }
              } else {
                selectDiscountIndex = i
                break
              }
            }
          }
          if (
            selectDiscountInfo.discount_type == 'coupon' &&
            selectDiscountInfo.type == 3 &&
            that.data.exchangeCouponData.hasSelectGoods == false
          ) {
            that.exchangeCouponInit(parseInt(selectDiscountInfo.value))
          }
        }
        newData['selectDiscountIndex'] = selectDiscountIndex
        newData['discountList'] = discounts
        newData['selectDiscountInfo'] = selectDiscountInfo
        newData['discount_cut_price'] = res.data.discount_cut_price
        newData['totalPayment'] = (+res.data.price).toFixed(2)
        newData['balance'] = res.data.balance
        newData['deduction'] = res.data.use_balance
        if (that.isFranchisee) {
          // 多商家联盟优惠
          let leagueBenefitList = res.data.extra_can_use_benefit.data
          if (leagueBenefitList && leagueBenefitList.length) {
            leagueBenefitList.unshift({
              title: '不使用优惠',
              name: '无',
              no_use_benefit: 1
            })
          }
          selectedLeagueBenefitInfo = res.data.extra_selected_benefit
          if (
            selectedLeagueBenefitInfo &&
            !selectedLeagueBenefitInfo.no_use_benefit
          ) {
            leagueBenefitList.forEach((coupon, index) => {
              if (
                selectedLeagueBenefitInfo.discount_type === coupon.discount_type
              ) {
                if (selectedLeagueBenefitInfo.discount_type === 'coupon') {
                  if (
                    selectedLeagueBenefitInfo.coupon_id === coupon.coupon_id
                  ) {
                    selectedLeagueBenefitIndex = index
                  }
                } else {
                  selectedLeagueBenefitIndex = index
                }
              }
            })
          }
          newData['leagueBenefitList'] = leagueBenefitList
          newData['selectedLeagueBenefitInfo'] = selectedLeagueBenefitInfo
          newData['selectedLeagueBenefitIndex'] = selectedLeagueBenefitIndex
          newData['leagueBenefitPrice'] = res.data.extra_discount_cut_price
        }
        that.setData(newData)
      },
      successStatusAbnormal: function (res) {
        setTimeout(() => {
          app.navigateBack()
        }, 2000)
      }
    })
  }
  getOptionalTime = () => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/GetTostoreNearestAppointmentTime',
      data: {
        sub_shop_app_id: that.franchiseeId
      },
      success: function (res) {
        that.setData({
          optionalTimeStart: res.data.substr(11, 5)
        })
      }
    })
  }
  remarkInput = e => {
    var value = e.target.value
    if (value.length > 30) {
      this.setData({
        remarkColor: 'red'
      })
    } else {
      this.setData({
        remarkColor: ''
      })
    }
    this.setData({
      orderRemark: value,
      remarkLength: value.length
    })
  }
  previewImage = e => {
    app.previewImage({
      current: e.currentTarget.dataset.src
    })
  }
  clickMinusButton = e => {
    var index = e.currentTarget.dataset.index,
      goods = this.data.goodsList[index]
    if (+goods.num <= 0) return
    this.changeGoodsNum(index, 'minus')
  }
  clickPlusButton = e => {
    var index = e.currentTarget.dataset.index
    this.changeGoodsNum(index, 'plus')
  }
  changeGoodsNum = (index, type) => {
    clearTimeout(this.changeNumTimeout[index])
    var goods = this.data.goodsList[index],
      currentNum = +goods.num,
      targetNum = type == 'plus' ? currentNum + 1 : currentNum - 1,
      that = this,
      data = {},
      changeGoodNum = 'changeGoodNum',
      param
    this.changeNumTimeout[index] = setTimeout(function () {
      if (targetNum == 0 && type == 'minus') {
        app.showModal({
          content: '确定从购物车删除该商品？',
          showCancel: true,
          confirm: function () {
            that.deleteGoods(index)
          }
        })
        return
      }
      that.cart_data_arr[index].num = targetNum
      param = {
        _app_id: app.getAppId(),
        app_id: app.getAppId(),
        session_key: app.getSessionKey(),
        goods_id: goods.goods_id,
        model_id: goods.model_id || '',
        num: targetNum,
        sub_shop_app_id: that.franchiseeId
      }
      app.sendRequest({
        url: '/index.php?r=AppShop/addCart',
        data: param,
        success: function (res) {
          that.cart_data_arr[index].num = targetNum
          data['goodsList[' + index + '].num'] = targetNum
          that.setData(data)
          that.getCalculationPrice(changeGoodNum)
        },
        successStatusAbnormal: function (res) {
          data = {}
          that.cart_data_arr[index].num = targetNum
          data['goodsList[' + index + '].num'] = targetNum
          data['goodsList[' + index + '].num'] = currentNum
          that.setData(data)
          app.showModal({
            content: res.data
          })
        },
        fail: function (res) {
          data = {}
          that.cart_data_arr[index].num = currentNum
          data['goodsList[' + index + '].num'] = currentNum
          that.setData(data)
        }
      })
    }, 500)
  }
  deleteGoods = index => {
    var goodsList = this.data.goodsList,
      that = this,
      listExcludeDelete,
      changeGoodNum = 'changeGoodNum'
    app.sendRequest({
      url: '/index.php?r=AppShop/deleteCart',
      method: 'post',
      data: {
        cart_id_arr: [this.cart_data_arr[index].cart_id],
        sub_shop_app_id: this.franchiseeId
      },
      success: function (res) {
        ; (listExcludeDelete = goodsList.concat([])).splice(index, 1)
        if (listExcludeDelete.length == 0) {
          app.turnBack()
          return
        }
        that.changeNumTimeout.splice(index, 1)
        that.cart_data_arr.splice(index, 1)
        that.setData({
          goodsList: listExcludeDelete,
          exchangeCouponData: {
            dialogHidden: true,
            hasSelectGoods: false,
            voucher_coupon_goods_info: {}
          }
        })
        that.getCalculationPrice(changeGoodNum)
      }
    })
  }
  confirmPayment = e => {
    var list = this.data.goodsList,
      appointmentTime = this.data.appointmentTime,
      that = this,
      phone = this.data.phone,
      locationId = this.data.locationId
    if (this.data.wayOfDine == 1 && this.data.changeValue == 1 && !locationId) {
      app.showModal({
        content: '请选择位置'
      })
      return
    }
    if (
      (this.data.shopInfo.is_phone == 1 && !util.isPhoneNumber(phone)) ||
      (phone && this.data.shopInfo.is_phone == 0 && !util.isPhoneNumber(phone))
    ) {
      app.showModal({
        content: '请填写正确的手机号码'
      })
      return
    }
    if (this.data.orderRemark.length > 30) {
      app.showModal({
        content: '备注字数超过限制'
      })
      return
    }
    if (this.data.wayOfDine == 2) {
      if (!appointmentTime) {
        app.showModal({
          content: '请选择预约时间'
        })
        return
      }
      appointmentTime =
        util.formatTime(new Date()).slice(0, 11) + appointmentTime
    }
    if (that.isPaysuccessFlag) {
      return
    }
    that.isPaysuccessFlag = true
    let utc = new Date().getTimezoneOffset() / 60
    let time_difference = 8 + utc
    let timezone_name = utc > 0 ? '西' + utc + '区' : '东' + utc * -1 + '区'
    app.sendRequest({
      url: '/index.php?r=AppShop/addCartOrder',
      method: 'post',
      data: {
        cart_arr: this.cart_data_arr,
        formId: e.target.formId,
        sub_shop_app_id: this.franchiseeId,
        selected_benefit: this.data.selectDiscountInfo,
        tostore_order_type: this.data.wayOfDine,
        tostore_appointment_time:
          this.data.wayOfDine == 2 ? appointmentTime : '',
        tostore_buyer_phone: this.data.phone,
        tostore_remark: this.data.orderRemark,
        location_id: this.data.wayOfDine == 2 ? '' : locationId,
        is_balance: this.data.useBalance ? 1 : 0,
        voucher_coupon_goods_info: this.data.exchangeCouponData
          .voucher_coupon_goods_info,
        time_difference: time_difference,
        timezone_name: timezone_name,
        superimposed: this.isFranchisee ? 1 : 0,
        is_multi: this.isFranchisee ? 1 : 0,
        extra_selected_benefit: this.data.selectedLeagueBenefitInfo
      },
      success: function (res) {
        setTimeout(() => {
          that.payOrder(res.data)
        }, 100)
        app.globalData.tostoreRefresh = true
      },
      successStatusAbnormal: function (res) {
        app.showModal({
          content: res.data,
          confirm: function () {
            ; (res.status == 11 || res.status == 12) && app.turnBack()
          }
        })
      },
      complete: function () {
        that.isPaysuccessFlag = false
      }
    })
  }
  payOrder = orderId => {
    var that = this
    function paySuccess() {
      var pagePath =
        '/orderMeal/pages/paySuccess/paySuccess?detail=' +
        orderId +
        (that.franchiseeId ? '&franchisee=' + that.franchiseeId : '')
      if (!that.franchiseeId) {
        app.sendRequest({
          hideLoading: true,
          url: '/index.php?r=AppMarketing/CheckAppCollectmeStatus',
          data: {
            order_id: orderId,
            sub_app_id: that.franchiseeId
          },
          success: function (res) {
            if (res.valid == 0) {
              pagePath += '&collectBenefit=1'
            }
            app.turnToPage(pagePath, 1)
          }
        })
      } else {
        app.turnToPage(pagePath, 1)
      }
    }
    function payFail() {
      app.turnToPage(
        '/orderMeal/pages/tostoreOrderDetail/tostoreOrderDetail?detail=' +
        orderId +
        (that.franchiseeId ? '&franchisee=' + that.franchiseeId : ''),
        1
      )
    }
    if (this.data.totalPayment == 0) {
      app.sendRequest({
        hideLoading: false,
        url: '/index.php?r=AppShop/paygoods',
        data: {
          order_id: orderId,
          total_price: 0
        },
        success: function (res) {
          paySuccess()
        },
        fail: function () {
          payFail()
        },
        successStatusAbnormal: function () {
          payFail()
        }
      })
      return
    }
    app.sendRequest({
      hideLoading: false,
      url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
      data: {
        order_id: orderId,
        sub_shop_app_id: that.franchiseeId
      },
      success: function (res) {
        var param = res.data
        param.orderId = orderId
        param.goodsType = 3
        param.success = paySuccess
        param.fail = payFail
        that.wxPay(param)
      },
      fail: function () {
        payFail()
      },
      successStatusAbnormal: function () {
        payFail()
      }
    })
  }
  wxPay = param => {
    var that = this
    app.requestPayment({
      timeStamp: param.timeStamp,
      nonceStr: param.nonceStr,
      package: param.package,
      signType: param.signType,
      paySign: param.paySign,
      success: function (res) {
        app.wxPaySuccess(param)
        param.success()
      },
      fail: function (res) {
        if (res.errMsg === 'requestPayment:fail cancel') {
          app.showModal({
            content: '支付已取消',
            complete: param.fail
          })
          return
        }
        app.showModal({
          content: '支付失败',
          complete: param.fail
        })
        app.wxPayFail(param, res.errMsg)
      }
    })
  }
  showDiscount = () => {
    this.setData({
      discountDialogHidden: false
    })
  }
  hideDiscount = () => {
    this.setData({
      discountDialogHidden: true
    })
  }
  chooseWayOfDine = e => {
    var wayOfDine = e.currentTarget.dataset.way,
      that = this
    this.setData({
      wayOfDine: wayOfDine
    })
    if (wayOfDine == 2) {
      this.getTostoreAppointBusinessTime()
    }
  }
  getTostoreAppointBusinessTime = () => {
    var that = this
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/getAvaliableTostoreAppointBusinessTime',
      method: 'post',
      data: {
        good_ids: that.cartGoodsIdArr,
        sub_shop_app_id: that.franchiseeId || ''
      },
      success: function (res) {
        if (res.data.length) {
          var businesssTimeString = ''
          for (var i = 0; i < res.data.length; i++) {
            businesssTimeString +=
              res.data[i].start_time.substring(0, 2) +
              ':' +
              res.data[i].start_time.substring(2, 4) +
              '-' +
              res.data[i].end_time.substring(0, 2) +
              ':' +
              res.data[i].end_time.substring(2, 4) +
              '/'
          }
          businesssTimeString =
            '可选时间：' +
            businesssTimeString.substring(0, businesssTimeString.length - 1)
          that.setData({
            businesssTimeString: businesssTimeString
          })
        }
      }
    })
  }
  bindTimeChange = date => {
    var time = `${date.getHours()}:${date.getMinutes()}`;
    this.setData({
      appointmentTime: time
    })
  }
  inputPhone = e => {
    var phone = e.target.value
    this.setData({
      phone: phone
    })
    app.setUserInfoStorage({
      phone: phone
    })
  }
  discountChange = index => {
    const that = this
    setTimeout(function () {
      that.setData({
        selectDiscountInfo: that.data.discountList[index],
        selectDiscountIndex: index,
        discountDialogHidden: true,
        'exchangeCouponData.hasSelectGoods': false,
        'exchangeCouponData.voucher_coupon_goods_info': {}
      })
      that.getCalculationPrice()
    }, 500)
  }
  location = e => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/locationDataList',
      data: {
        page_size: 1000,
        sub_shop_app_id: that.franchiseeId || ''
      },
      success: function (res) {
        if (res.data.length) {
          that.setData({
            location_data_arr: res.data
          })
        }
      }
    })
  }
  bindLocationChange = index => {
    var that = this
    that.setData({
      locationNum: that.data.location_data_arr[index].title,
      selectLocationId: that.data.location_data_arr[index].id,
      locationId: that.data.location_data_arr[index].id,
      locationSelect: true,
      changeValue: 1
    })
  }
  radioLocationChange = e => {
    var that = this,
      changeValue,
      locationId = '',
      value = e.target.value;
    if (value == 0) {
      locationId = 0
      changeValue = 0
    } else if (value == 1) {
      locationId = that.data.selectLocationId
      changeValue = 1
    } else {
      locationId = app.globalData.urlLocationId
      changeValue = 2
    }
    that.setData({
      locationId: locationId,
      changeValue: changeValue
    })
  }
  getDataId = e => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/getLocationData',
      data: {
        id: app.globalData.urlLocationId,
        sub_shop_app_id: that.franchiseeId || ''
      },
      success: function (res) {
        that.setData({
          locationTitle: res.data.title
        })
      }
    })
  }
  useBalanceChange = checked => {
    this.setData({
      useBalance: checked
    })
    this.getCalculationPrice()
  }
  exchangeCouponInit = id => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/getGoods',
      data: {
        data_id: id
      },
      success: function (res) {
        var goods = res.data[0].form_data
        var goodsModel = []
        var selectModelInfo = {
          models: [],
          price: 0,
          modelId: '',
          models_text: '',
          imgurl: ''
        }
        if (goods.model_items.length) {
          selectModelInfo['price'] = Number(goods.model_items[0].price)
          selectModelInfo['imgurl'] = goods.model_items[0].img_url
          selectModelInfo['modelId'] = goods.model_items[0].id
        } else {
          selectModelInfo['price'] = Number(goods.price)
          selectModelInfo['imgurl'] = goods.cover
        }
        for (var key in goods.model) {
          if (key) {
            goodsModel.push(goods.model[key]) // 转成数组
            selectModelInfo['models'].push(goods.model[key].subModelId[0])
            selectModelInfo['models_text'] +=
              '“' + goods.model[key].subModelName[0] + '” '
          }
        }
        goods.model = goodsModel // 将原来的结构转换成数组
        that.setData({
          'exchangeCouponData.dialogHidden': false, // 显示模态框
          'exchangeCouponData.goodsInfo': goods,
          'exchangeCouponData.selectModelInfo': selectModelInfo
        })
      }
    })
  }
  exchangeCouponHideDialog = () => {
    this.setData({
      selectDiscountInfo: this.data.discountList[0],
      selectDiscountIndex: 0,
      'exchangeCouponData.dialogHidden': true,
      'exchangeCouponData.hasSelectGoods': false,
      'exchangeCouponData.voucher_coupon_goods_info': {}
    })
    this.getCalculationPrice()
  }
  exchangeCouponSelectSubModel = e => {
    var dataset = e.target.dataset,
      modelIndex = dataset.modelIndex,
      submodelIndex = dataset.submodelIndex,
      data = {},
      selectModels = this.data.exchangeCouponData.selectModelInfo.models,
      model = this.data.exchangeCouponData.goodsInfo.model,
      text = ''
    selectModels[modelIndex] = model[modelIndex].subModelId[submodelIndex]
    for (let i = 0; i < selectModels.length; i++) {
      let selectSubModelId = model[i].subModelId
      for (let j = 0; j < selectSubModelId.length; j++) {
        if (selectModels[i] == selectSubModelId[j]) {
          text += '“' + model[i].subModelName[j] + '” '
        }
      }
    }
    data['exchangeCouponData.selectModelInfo.models'] = selectModels
    data['exchangeCouponData.selectModelInfo.models_text'] = text
    this.setData(data)
    this.exchangeCouponResetSelectCountPrice()
  }
  exchangeCouponResetSelectCountPrice = () => {
    var that = this,
      selectModelIds = this.data.exchangeCouponData.selectModelInfo.models.join(
        ','
      ),
      modelItems = this.data.exchangeCouponData.goodsInfo.model_items,
      data = {}
    for (var i = modelItems.length - 1; i >= 0; i--) {
      if (modelItems[i].model == selectModelIds) {
        data['exchangeCouponData.selectModelInfo.stock'] = modelItems[i].stock
        data['exchangeCouponData.selectModelInfo.price'] = modelItems[i].price
        data['exchangeCouponData.selectModelInfo.modelId'] = modelItems[i].id
        data['exchangeCouponData.selectModelInfo.imgurl'] =
          modelItems[i].img_url
        break
      }
    }
    this.setData(data)
  }
  exchangeCouponConfirmGoods = () => {
    let that = this
    let goodsInfo = that.data.exchangeCouponData.goodsInfo
    let model = goodsInfo.model
    let selectModels = that.data.exchangeCouponData.selectModelInfo.models
    let model_value_str = ''
    if (selectModels.length > 0) {
      model_value_str = '('
      for (let i = 0; i < selectModels.length; i++) {
        let selectSubModelId = model[i].subModelId
        for (let j = 0; j < selectSubModelId.length; j++) {
          if (selectModels[i] == selectSubModelId[j]) {
            model_value_str += model[i].subModelName[j] + '|'
          }
        }
      }
      model_value_str += ')'
    }
    goodsInfo['model_value_str'] = model_value_str
    that.setData({
      'exchangeCouponData.dialogHidden': true,
      'exchangeCouponData.selectModelInfo': {},
      'exchangeCouponData.hasSelectGoods': true,
      'exchangeCouponData.voucher_coupon_goods_info': {
        goods_id: goodsInfo.id,
        num: 1,
        model_id: that.data.exchangeCouponData.selectModelInfo.modelId
      },
      'exchangeCouponData.goodsInfo': goodsInfo
    })
    that.getCalculationPrice()
  }
  GetTostoreWaitingRule = () => {
    let _this = this
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/GetTostoreWaitingRule',
      data: {
        sub_shop_app_id: _this.franchiseeId || ''
      },
      method: 'get',
      success: function (res) {
        let wayOfDine = 1
        for (let i in res.data.tostore_type) {
          if (
            res.data.tostore_type[i].tostore_order_type == 2 &&
            res.data.tostore_type[i].use == 1 &&
            res.data.used_tostore_type == 1
          ) {
            wayOfDine = 2
            setTimeout(function () {
              _this.getTostoreAppointBusinessTime()
            }, 100)
          }
        }
        _this.setData({
          shopInfo: res.data,
          wayOfDine: wayOfDine
        })
      }
    })
  }
  leagueDiscountChange = index => {
    let that = this
    setTimeout(() => {
      that.setData({
        selectedLeagueBenefitInfo: that.data.leagueBenefitList[index],
        selectedLeagueBenefitIndex: index
      })
      that.getCalculationPrice()
    }, 500)
  }

  render() {
    let {
      showGetUserInfo,
      goodsList,
      exchangeCouponData,
      remarkColor,
      remarkLength,
      wayOfDine,
      shopInfo,
      businesssTimeString,
      optionalTimeStart,
      optionalTimeEnd,
      appointmentTime,
      changeValue,
      locationTitle,
      isUrlLocationId,
      location_data_arr,
      locationNum,
      selectDiscountIndex,
      discountList,
      selectDiscountInfo,
      discount_cut_price,
      selectedLeagueBenefitIndex,
      leagueBenefitList,
      selectedLeagueBenefitInfo,
      leagueBenefitPrice,
      useBalance,
      deduction,
      balance,
      phone,
      totalPayment,
      dialogHidden,
      selectModelInfo,
      goodsInfo
    } = this.state

    // Picker组件数据转换
    if (Array.isArray(discountList)) {
      discountList = discountList.map((item, index) => ({ label: item.title, value: index }));
    }
    if (Array.isArray(leagueBenefitList)) {
      leagueBenefitList = leagueBenefitList.map((item, index) => ({ label: item.title, value: index }));
    }
    if (Array.isArray(location_data_arr)) {
      location_data_arr = location_data_arr.map((item, index) => ({ label: item.title, value: index }));
    }

    return (
      <div className="official-page preview-order-detail">
        <React.Fragment>
          <div className="previewOrder-wrap page" id="previewOrder">
            {goodsList.map((goods, goodsIndex) => {
              return (
                <React.Fragment key={goodsIndex}>
                  <div className="previewOrder-goods-list previewOrder-section">
                    <div className="previewOrder-goods-item">
                      <img
                        className="list-goods-cover"
                        src={goods.cover}
                        mode="aspectFill"
                      />
                      <div className="list-goods-content">
                        <div className="list-goods-title">{goods.title}</div>
                        {goods.model_value_str && (
                          <div className="list-goods-model">
                            {goods.model_value_str}
                          </div>
                        )}
                        <div className="list-goods-price">
                          {goods.integral != '2' ? (
                            <React.Fragment>
                              <span>{'¥' + goods.price}</span>
                            </React.Fragment>
                          ) : (
                              <React.Fragment>
                                {goods.price != '0.00' && (
                                  <span>{'¥' + goods.price}</span>
                                )}
                                {goods.price != '0.00' &&
                                  goods.use_integral != 0 && <span>+</span>}
                                {goods.use_integral != 0 && (
                                  <span>{goods.use_integral + '积分'}</span>
                                )}
                              </React.Fragment>
                            )}
                        </div>
                      </div>
                      <div className="list-goods-right" style={convertLineStyleData('top:13px;')}>
                        <div className="quantity">
                          <label className="minus"></label>
                          <span className="buy-goods-count">{goods.num}</span>
                          <label className="plus"></label>
                          <div
                            className="response-area response-area-minus"
                            data-index={goodsIndex}
                            onClick={this.clickMinusButton}
                          ></div>
                          <div
                            className="response-area response-area-plus"
                            data-index={goodsIndex}
                            onClick={this.clickPlusButton}
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              )
            })}
            {exchangeCouponData.hasSelectGoods && (
              <div className="previewOrder-goods-list previewOrder-section">
                <div className="previewOrder-goods-item">
                  <img
                    className="list-goods-cover"
                    src={exchangeCouponData.goodsInfo.cover}
                    mode="aspectFill"
                  />
                  <div className="list-goods-content">
                    <div className="list-goods-title">
                      {exchangeCouponData.goodsInfo.title}
                    </div>
                    {exchangeCouponData.goodsInfo.model_value_str && (
                      <div className="list-goods-model">
                        {exchangeCouponData.goodsInfo.model_value_str}
                      </div>
                    )}
                    <div className="list-goods-price">
                      <div className="gift-text">赠品</div>
                    </div>
                    <div className="list-goods-right" style={convertLineStyleData('top:13px;')}>
                      <div className="quantity">
                        <span>数量：</span>
                        <span className="buy-goods-count">1</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="previewOrder-section">
              <div className="previewOrder-section-title">备注:</div>
              <textarea
                onInput={this.remarkInput}
                style={convertLineStyleData('border: none;')}
              ></textarea>
              <span
                style={convertLineStyleData(
                  'background-color:#e9e7e8;display:block;font-size:12px;text-align:right;padding-right:4px;color:' +
                  (remarkColor || 'black') +
                  ';'
                )}
              >
                {(remarkLength || 0) + '/30'}
              </span>
            </div>
            <div className="previewOrder-section">
              {shopInfo && shopInfo.used_tostore_type == 2 && (
                <div>
                  <div className="options-group">
                    <div
                      className="options-item-left"
                      onClick={this.chooseWayOfDine}
                      data-way="1"
                    >
                      <div
                        className={
                          'options-item-circle ' +
                          (wayOfDine == 1 ? 'selected' : '')
                        }
                      ></div>
                      <div>{shopInfo.tostore_type[0].name || '点餐'}</div>
                    </div>
                    <div
                      className="options-item-right"
                      onClick={this.chooseWayOfDine}
                      data-way="2"
                    >
                      <div
                        className={
                          'options-item-circle ' +
                          (wayOfDine == 2 ? 'selected' : '')
                        }
                      ></div>
                      <div>{shopInfo.tostore_type[1].name || '预约'}</div>
                    </div>
                    <div className="options-group-crossband"></div>
                  </div>
                </div>
              )}
              {shopInfo && shopInfo.tostore_type.map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    {shopInfo.used_tostore_type != 2 &&
                      item.tostore_order_type == 2 &&
                      item.use == 1 &&
                      wayOfDine == 2 && (
                        <div>
                          <div
                            className="options-item-circle selected"
                            style={convertLineStyleData('display:inline-block;vertical-align:middle;margin-right:5px;')}
                          ></div>
                          {item.name}
                        </div>
                      )}
                    {shopInfo.used_tostore_type != 2 &&
                      item.tostore_order_type == 1 &&
                      item.use == 1 &&
                      wayOfDine == 1 && (
                        <div>
                          <div
                            className="options-item-circle selected"
                            style={convertLineStyleData('display:inline-block;vertical-align:middle;margin-right:5px;')}
                          ></div>
                          {item.name}
                        </div>
                      )}
                    {item.tostore_order_type == 2 &&
                      item.use == 1 &&
                      wayOfDine == 2 && (
                        <div>
                          <div style={convertLineStyleData('font-size:12px;color:#ffcc01;margin: 3px 0;')}>
                            {businesssTimeString}
                          </div>
                          <div className="previewOrder-time-picker">
                            <DatePicker
                              mode="time"
                              minDate={new Date(2000 + ' ' + optionalTimeStart)}
                              maxDate={optionalTimeEnd ? new Date(2000 + ' ' + optionalTimeEnd) : new Date(2030, 1, 1, 23, 59, 59)}
                              value={isNaN(new Date(2000 + ' ' + appointmentTime).getTime()) ? null : new Date(2000 + ' ' + appointmentTime)}
                              onChange={this.bindTimeChange}>
                              <div className="picker">
                                {appointmentTime || '请点击选择到店时间'}
                              </div>
                            </DatePicker>
                          </div>
                        </div>
                      )}
                    {location_data_arr &&
                      item.tostore_order_type == 1 &&
                      item.use == 1 &&
                      wayOfDine == 1 && (
                        <div className="previewOrder-section-location">
                          <div style={convertLineStyleData('text-align:left;margin-bottom:10px;')}>
                            {shopInfo.project_title + ':'}
                          </div>
                          <div style={convertLineStyleData('color:#919191;font-size: 13px;')}>
                            {isUrlLocationId && (
                              <label style={convertLineStyleData('margin-right:10px;')}>
                                <Radio
                                  checked={changeValue == 2}
                                  color="#ff7100"
                                  value="2"
                                  onChange={this.radioLocationChange}
                                ></Radio>
                                {locationTitle}
                              </label>
                            )}
                            <label style={convertLineStyleData('margin-right:10px;')}>
                              <Radio className="radio" value="0" checked={changeValue == 0} onChange={this.radioLocationChange}>自助</Radio>
                            </label>
                            <label style={convertLineStyleData('margin-right:10px;')}>
                              <Radio className="radio" value="1" checked={changeValue == 1} onChange={this.radioLocationChange}>换位置</Radio>
                            </label>
                            <div className="location-section">
                              <Picker
                                cols={1}
                                onChange={this.bindLocationChange}
                                value={[index]}
                                data={location_data_arr}
                              >
                                <div className="picker">
                                  {locationNum || '请选择'}
                                </div>
                              </Picker>
                            </div>
                          </div>
                        </div>
                      )}
                  </React.Fragment>
                )
              })}
            </div>
            {!!discountList.length && (
              <div
                className="previewOrder-section discount-way"
                onClick={this.showDiscount}
              >
                <div className="previewOrder-section-title">优惠方式:</div>
                <div className="ico-moon icon-rightarrow"></div>
                <Picker
                  cols={1}
                  onChange={this.discountChange}
                  value={[selectDiscountIndex]}
                  data={discountList}
                  style={convertLineStyleData('margin-bottom:-12rpx;')}
                >
                  <div className="select-discount-title">
                    <span className="pull-left">{selectDiscountInfo.name}</span>
                    <span
                      className="pull-right"
                      hidden={selectDiscountIndex == 0}
                    >
                      {'- ¥' + discount_cut_price}
                    </span>
                  </div>
                </Picker>
              </div>
            )}
            {!!leagueBenefitList.length && (
              <div className="previewOrder-section discount-way">
                <div className="previewOrder-section-title">联盟优惠:</div>
                <div className="ico-moon icon-rightarrow"></div>
                <Picker
                  onChange={this.leagueDiscountChange}
                  value={[selectedLeagueBenefitIndex]}
                  data={leagueBenefitList}
                  style={convertLineStyleData('margin-bottom:-12rpx;')}
                >
                  <div className="select-discount-title">
                    <span className="pull-left">
                      {selectedLeagueBenefitInfo.name}
                    </span>
                    <span
                      className="pull-right"
                      hidden={selectedLeagueBenefitIndex == 0}
                    >
                      {'- ¥' + leagueBenefitPrice}
                    </span>
                  </div>
                </Picker>
              </div>
            )}
            {balance != 0 && (
              <div className="previewOrder-section">
                <div className="use-balance-option">
                  <span>使用储值金</span>
                  <Switch
                    className="pull-right"
                    checked={useBalance}
                    onChange={this.useBalanceChange}
                    color="#ff7100"
                  ></Switch>
                </div>
                <div
                  hidden={!useBalance}
                  className="select-discount-title"
                  style={convertLineStyleData('margin-top:9px;margin-bottom:-12rpx;')}
                >
                  储值金抵现
                  <span className="pull-right">{'- ¥' + deduction}</span>
                </div>
              </div>
            )}
            <div className="previewOrder-section">
              <div className="previewOrder-section-title">
                {'手机号码' + (shopInfo && shopInfo.is_phone == 1 ? '(必填)' : '') + ':'}
              </div>
              <input
                type="number"
                placeholder="请输入11位手机号码"
                onInput={this.inputPhone}
                value={phone}
                onChange={() => { }}
              />
            </div>
            <form>
              <button type="button" onClick={this.confirmPayment} className="previewOrder-pay-btn">
                {'确认支付 ¥' + totalPayment}
              </button>
            </form>
            <ExchangeCouponUseDialogTmpl data={exchangeCouponData} self={this} />
          </div>
        </React.Fragment>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/preview-order-detail/PreviewOrderDetail.jsx